import { AfterViewInit, Directive, Input } from '@angular/core';

import { InfiniteScrollService } from './infinite.scroll.service';
import { WindowRefService } from './../../service/window/window.service';

@Directive({
    selector: '[ngxInfiniteScroll]'
})
export class InfiniteScrollDirective implements AfterViewInit {
    @Input() infiniteScrOffsetElements: Array<string>;
    @Input() infiniteScrOffset = 0;

    constructor(
        private infinScrService: InfiniteScrollService
    ) {}

    ngAfterViewInit(): void {
        this.infinScrService.createScrollWatcher(this.infiniteScrOffset, this.infiniteScrOffsetElements);
    }
}
